import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { X } from "lucide-react";
import { site } from "../content";

// Vídeo em tela cheia no hero que "acompanha" o scroll:
// ao rolar a página, ele se transforma em um mini-player flutuante
// e continua reproduzindo. Pode ser fechado; volta ao topo = tela cheia.
export default function BackgroundVideo() {
  const [mini, setMini] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const past = window.scrollY > window.innerHeight * 0.6;
      setMini(past);
      if (!past) setDismissed(false);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const hidden = mini && dismissed;

  return (
    <motion.div
      layout
      transition={{ duration: 0.75, ease: [0.22, 1, 0.36, 1] }}
      data-testid="scroll-video"
      className={
        !mini
          ? "fixed inset-0 z-0 overflow-hidden bg-ink"
          : hidden
            ? "pointer-events-none fixed bottom-24 left-4 z-[75] aspect-video w-44 overflow-hidden rounded-2xl opacity-0 md:bottom-8 md:left-8 md:w-72"
            : "fixed bottom-24 left-4 z-[75] aspect-video w-44 overflow-hidden rounded-2xl border border-white/15 shadow-[0_20px_60px_rgba(0,0,0,0.65)] md:bottom-8 md:left-8 md:w-72"
      }
    >
      <video
        className="h-full w-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        poster={site.assets.bgPoster}
        data-testid="background-video"
      >
        <source src={site.assets.bgVideo} type="video/mp4" />
      </video>

      {!mini && (
        <>
          <div className="absolute inset-0 bg-gradient-to-b from-ink/70 via-ink/40 to-ink/85" />
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_60%_at_50%_30%,transparent,rgba(5,5,5,0.5))]" />
          <div className="noise absolute inset-0 opacity-[0.05]" />
        </>
      )}

      {mini && !hidden && (
        <>
          <span className="pointer-events-none absolute bottom-2 left-3 font-display text-[9px] font-bold uppercase tracking-[0.25em] text-white/85">
            Barber Steamer em ação
          </span>
          <button
            onClick={() => setDismissed(true)}
            data-testid="scroll-video-close"
            aria-label="Fechar vídeo"
            className="absolute right-2 top-2 flex h-7 w-7 items-center justify-center rounded-full bg-black/60 text-white/80 backdrop-blur-sm transition-colors duration-300 hover:bg-black/85 hover:text-white"
          >
            <X className="h-3.5 w-3.5" aria-hidden="true" />
          </button>
        </>
      )}
    </motion.div>
  );
}
